import { alertaTypes } from "../actions/types";

const initialState = {
  show: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case alertaTypes.SHOW_MENU:
      return {
        ...state,
        show: !state.show
      }
    default:
      return state;
  }
}